import React, { SyntheticEvent } from 'react';

export const useScrollToAnchor = () => {
  return React.useCallback(
    (anchor: string) => (e: SyntheticEvent) => {
      e.preventDefault();
      const offsetTop = document.getElementById(anchor)?.offsetTop;
      if (offsetTop) {
        window.history.pushState(null, '', `#${anchor}`);
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    },
    [],
  );
};
